<form #humanResourcesAndTaxesParametersForm="ngForm">
    <kiwi-parameters-tab-content-header [titleLabelKey]="'parameters.human.resources.and.taxes.taxes.title'"
                                    [saveDisabled]="areParametersReadonly()"
                                    (saved)="updateParameters()"></kiwi-parameters-tab-content-header>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <p [i18nKey]="'parameters.human.resources.and.taxes.taxes.description'"></p>

    <table class="_tableColor">
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.human.resources.and.taxes.taxes.overdraft.interest.rate'"></td>
            <td>
                <kiwi-percentage-input [(ngModel)]="parameters.overdraftAnnualInterestRate"
                                       name="overdraftAnnualInterestRate"
                                       [disabled]="areParametersReadonly()"></kiwi-percentage-input>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'parameters.human.resources.and.taxes.taxes.tax.rate'"></td>
            <td>
                <kiwi-percentage-input [(ngModel)]="parameters.taxRate"
                                       name="taxRate"
                                       [disabled]="areParametersReadonly()"></kiwi-percentage-input>
            </td>
        </tr>
        </tbody>
    </table>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <h2 class="_sansSerif _primary"[i18nKey]="'parameters.human.resources.and.taxes.human.resources.title'"></h2>

    <kiwi-spacer [size]="8"></kiwi-spacer>

    <p [i18nKey]="'parameters.human.resources.and.taxes.human.resources.description'"></p>

    <table class="_tableColor">
        <tbody>
        <tr>
            <td [i18nKey]="'parameters.human.resources.and.taxes.human.resources.employer.contribution'"></td>
            <td>
                <kiwi-percentage-input [(ngModel)]="parameters.employerContribution"
                                       name="employerContribution"
                                       [disabled]="areParametersReadonly()"></kiwi-percentage-input>
            </td>
        </tr>
        <tr>
            <td [i18nKey]="'human.resources.severance.pay.in.months'"></td>
            <td>
                <input type="number"
                       name="severancePayInMonths"
                       [(ngModel)]="parameters.severancePayInMonths"
                       [disabled]="areParametersReadonly()" />
            </td>
        </tr>
        </tbody>
    </table>
</form>
